export const state = () => ({
    sendQuestNotificationTitle: "",
    sendQuestNotificationMessage: "",
    sendQuestNotificationType: "",
    sendQuestNotificationParams: null,

    isOpenSendQuestNotification: false,
  })

export const mutations = {
  openSendQuestNotification: function (state, {
    title,
    message,
    params
  }) {
    state.sendQuestNotificationTitle = title
    state.sendQuestNotificationMessage = message;
    state.isOpenSendQuestNotification = true;
    state.sendQuestNotificationType = params?.type || "";
    state.sendQuestNotificationParams = params || null;
  },
  closeSendQuestNotification: function (state) {
    state.isOpenSendQuestNotification = false;

    state.sendQuestNotificationTitle = "";
    state.sendQuestNotificationMessage = "";
    state.sendQuestNotificationType = "";
    state.sendQuestNotificationParams = null;
  },
}

export const actions = {
  showNotification({ commit }, payload) {
    commit('openSendQuestNotification', payload)
  },
  hideNotification({ commit }) {
    commit('closeSendQuestNotification')
  }
}
